import React from 'react';
import { connect } from 'react-redux';

import { Divider } from 'redpoints-front-components/index';

import {
  getIncidentDetailsAccountPermissions,
  getIncidentDetailsForceValidation,
  getIncidentDetailsLinkDataPermissions,
  getIncidentDetailsSellerPermissions,
} from '../../../reducers/reporting/incidentDetails';
import IncidentDetailsEvidences from './IncidentDetailsEvidences';
import IncidentDetailsLinkDataContentExtractedData from './IncidentDetailsLinkDataContentExtractedData';
import IncidentDetailsLinkDataContentFixedData from './IncidentDetailsLinkDataContentFixedData';

const IncidentDetailsLinkDataContent = ({
  accountData,
  accountLinkDataChange,
  accountLinkDataValidate,
  adLinks,
  commonLinkDataChange,
  commonLinkDataValidate,
  destinationLinks,
  enforcementStatus,
  evidenceChange,
  evidenceData,
  evidenceIsMandatory,
  evidenceValidate,
  evidencesIsLoading,
  forceValidation,
  hasAccountPermission,
  hasLinkDataPermissions,
  hasSellerPermission,
  isAdDetectionLink,
  isSearchLoading,
  linkData,
  linkId,
  linkImageListLinkDataChange,
  linkImageListLinkDataValidate,
  linkInfo,
  linkMetadata,
  linkPriceListChange,
  linkPriceListValidate,
  monitorData,
  multimediaFileLinkDataChange,
  multimediaFileLinkDataValidate,
  offerListingChange,
  offerListingValidate,
  onSearch,
  overallMultimediaChange,
  overallMultimediaValidate,
  priority,
  productListingChange,
  productListingValidate,
  searchStatus,
  sellerData,
  sellerLinkDataChange,
  sellerLinkDataValidate,
  socialMediaLinkDataChange,
  socialMediaLinkDataValidate,
}) => (
  <div className="incident-details-link-data-content-container">
    <IncidentDetailsLinkDataContentFixedData
      adLinks={adLinks}
      destinationLinks={destinationLinks}
      isAdDetectionLink={isAdDetectionLink}
      linkId={linkId}
      linkInfo={linkInfo}
      monitorData={monitorData}
      priority={priority}
    />
    <IncidentDetailsLinkDataContentExtractedData
      accountData={accountData}
      accountLinkDataChange={accountLinkDataChange}
      accountLinkDataValidate={accountLinkDataValidate}
      commonLinkDataChange={commonLinkDataChange}
      commonLinkDataValidate={commonLinkDataValidate}
      forceValidation={forceValidation}
      hasAccountPermission={hasAccountPermission}
      hasLinkDataPermissions={hasLinkDataPermissions}
      hasSellerPermission={hasSellerPermission}
      linkData={linkData}
      linkImageListLinkDataChange={linkImageListLinkDataChange}
      linkImageListLinkDataValidate={linkImageListLinkDataValidate}
      linkMetadata={linkMetadata}
      linkPriceListChange={linkPriceListChange}
      linkPriceListValidate={linkPriceListValidate}
      multimediaFileLinkDataChange={multimediaFileLinkDataChange}
      multimediaFileLinkDataValidate={multimediaFileLinkDataValidate}
      offerListingChange={offerListingChange}
      offerListingValidate={offerListingValidate}
      overallMultimediaChange={overallMultimediaChange}
      overallMultimediaValidate={overallMultimediaValidate}
      productListingChange={productListingChange}
      productListingValidate={productListingValidate}
      sellerData={sellerData}
      sellerLinkDataChange={sellerLinkDataChange}
      sellerLinkDataValidate={sellerLinkDataValidate}
      socialMediaLinkDataChange={socialMediaLinkDataChange}
      socialMediaLinkDataValidate={socialMediaLinkDataValidate}
      isSearchLoading={isSearchLoading}
      onSearch={onSearch}
      searchStatus={searchStatus}
    />
    <Divider />
    <IncidentDetailsEvidences
      enforcementStatus={enforcementStatus}
      evidenceChange={evidenceChange}
      evidenceValidate={evidenceValidate}
      evidences={evidenceData}
      isLoading={evidencesIsLoading}
      isMandatory={evidenceIsMandatory}
    />
  </div>
);

const mapStateToProps = state => ({
  forceValidation: getIncidentDetailsForceValidation(state),
  hasAccountPermission: getIncidentDetailsAccountPermissions(state),
  hasLinkDataPermissions: getIncidentDetailsLinkDataPermissions(state),
  hasSellerPermission: getIncidentDetailsSellerPermissions(state),
});

export default connect(mapStateToProps)(IncidentDetailsLinkDataContent);
